<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copy"></a><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="copyright">© 2008 by New York University<br/>All rights reserved</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Bulkeley, Kelly, 1962 –<br/>Dreaming in the world’s religions : a comparative history / Kelly Bulkeley.<br/>p.   cm.<br/>Includes bibliographical references (p.    ) and index.<br/>ISBN-13: 978-0-8147-9956-7 (cl : alk. paper)<br/>ISBN-10: 0-8147-9956-6 (cl : alk. paper)<br/>ISBN-13: 978-0-8147-9957-4 (pb : alk. paper)<br/>ISBN-10: 0-8147-9957-4 (pb : alk. paper)<br/>1. Dreams—Religious aspects — History. 2. Religions—History. I. Title.<br/>BL65.D67B83  2008<br/>204’.2—dc22              2008004107</p>
<p class="copyright">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.</p>
<p class="copyright">Manufactured in the United States of America</p>
<p class="copyright">c 10 9 8 7 6 5 4 3 2 1<br/>p 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0be423a3